import { getEnv } from '../../env';

export const env = getEnv();
